import {
  IconButton,
  ListItemText,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { IconProps } from '@material-ui/core/Icon';
import { ArrowDropDown, Clear } from '@material-ui/icons';
import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components';

import { InputFieldProps } from 'Elements/Form';

const selectProps = {
  MenuProps: {
    MenuListProps: { style: { maxHeight: 400, overflowY: 'auto' as 'auto' } }
  }
};

/**
 * Enhanced material ui Select component with visible *placeholder*
 * and a *reset* button on selected value.
 */
export function Dropdown({ children, ...props }: InputFieldProps) {
  const reset = useCallback(() => {
    if (props.onChange) {
      props.onChange({ target: { name: props.name, value: null } } as any);
    }
  }, [props]);

  const inputProps = useMemo(() => {
    if (!props.disabled) {
      return {
        displayEmpty: true,
        IconComponent: (iprops: IconProps) => (
          <CustomDropdownIcon {...iprops} reset={reset} value={props.value} />
        )
      };
    }
  }, [props.disabled, props.value, reset]);

  return (
    <TextField
      {...props}
      select
      inputProps={inputProps}
      SelectProps={selectProps}
    >
      {props.placeholder && (
        <MenuItem disabled selected value="">
          <Placeholder>{props.placeholder}</Placeholder>
        </MenuItem>
      )}

      {children}
    </TextField>
  );
}

function CustomDropdownIcon({ value, reset, ...props }: any) {
  if (value === '') {
    return <ArrowDropDown {...props} />;
  }

  return (
    <ClearIconButton {...props} onClick={reset}>
      <Clear fontSize="small" />
    </ClearIconButton>
  );
}

const ClearIconButton = styled(IconButton)`
  && {
    pointer-events: auto;
    top: calc(50% - 21px);
    transform: translateX(11px);
  }
`;

const Placeholder = styled(ListItemText)`
  && {
    opacity: 0.5;
  }
`;
